export const AVAILABLE_COMMUNICATION_BOARD_SECTIONS = ['supplier_status', 'additional_sales_status', 'important_info']

export const SALES_SCRIPT_SECTIONS = {
  ENERGY: 'sales_script_energy',
  TELECOM: 'sales_script_telecom',
}

// Shown on the Italian home, split on their headings 3: see HomePage/HomeMessages.
export const HOME_BOARD_SECTIONS = {
  WELCOME: 'home_welcome',
  SCRIPTS: 'home_scripts',
}
